/* Dearingold global behaviour: cart count, toast, mobile menu, mega-menu, scroll reveal, slot overlay.
   Talks only to Shopify's standard Ajax Cart API so it works unchanged on a real store. */
(() => {
  const DG = (window.DG = window.DG || {});

  DG.cart = {
    async get() { return (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json(); },
    async add(items) {
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      const body = await res.json();
      if (!res.ok) throw new Error(body.description || body.message || 'Could not add to cart');
      DG.cart.refreshCount();
      return body;
    },
    async change(line, quantity) {
      const res = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity }) });
      const body = await res.json();
      DG.cart.setCount(body.item_count);
      return body;
    },
    async refreshCount() { const c = await DG.cart.get(); DG.cart.setCount(c.item_count); return c; },
    setCount(n) { document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = n; el.dataset.count = n; }); },
  };

  DG.money = (cents) => '$' + (Number(cents || 0) / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\.00$/, '');

  DG.toast = (html, ms = 4200) => {
    const t = document.querySelector('[data-toast]');
    if (!t) return;
    t.innerHTML = html;
    t.classList.add('is-on');
    clearTimeout(DG._toastT);
    DG._toastT = setTimeout(() => t.classList.remove('is-on'), ms);
  };

  document.addEventListener('DOMContentLoaded', () => {
    // Mobile menu
    const toggle = document.querySelector('[data-menu-toggle]');
    const mnav = document.querySelector('[data-mobile-nav]');
    toggle?.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(open));
      mnav.setAttribute('open-state', String(open));
      toggle.textContent = open ? 'Close' : 'Menu';
    });
    // Close mega menus on outside click / Escape
    const megas = [...document.querySelectorAll('[data-mega]')];
    document.addEventListener('click', (e) => megas.forEach((d) => { if (!d.contains(e.target)) d.removeAttribute('open'); }));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') megas.forEach((d) => d.removeAttribute('open')); });

    // Reveal on scroll
    const els = document.querySelectorAll('[data-reveal]');
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' });
      els.forEach((el) => io.observe(el));
    } else els.forEach((el) => el.classList.add('is-in'));

    // Prototype: show image-slot ids (maps to docs/ARTWORK-PROMPTS.md)
    document.querySelector('[data-toggle-slots]')?.addEventListener('click', (e) => {
      document.body.classList.toggle('show-slots');
      e.currentTarget.textContent = document.body.classList.contains('show-slots') ? 'hide image slots' : 'show image slots';
    });
  });
})();
